export default __webpack_public_path__ + "static/media/parentScreen.2422aa0f.png";